import { BeneficiariosAsistenciaMedicaEntity } from "./beneficiarios_asistencia_medica_entity";
import { FormaPagoEntity } from "./detalle_vehiculo_entity";
export class DetalleAsistenciaMedica {
    constructor(
        public CodigoUsuarioExtranet?: number,
        public CodigoProducto?: number,
        public CodigoCliente?: number,
        public CiudadCodigo?: number,
        public CodigoAsistencia?: number,
        public CodigoPlan?: number,
        public CodigoTitular?: number,
        public NombreTitular?: string,
        public ApellidoPaternoTitular?: string,
        public ApellidoMaternoTitular?: string,
        public FechaNacimientoTitular?: Date,
        public Beneficiarios?: BeneficiariosAsistenciaMedicaEntity[],
        public BeneficiariosNuevos?: BeneficiariosAsistenciaMedicaEntity[],
        public Poliza?: string,
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public CodigoEjecutivoCuenta?: number,
        public FormaPago?: FormaPagoEntity,
        public MantenerFormaPago?: boolean
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/detalle_asistencia_medica.ts